<template>
	<v-main>
		<v-container fluid>
			<FormPage title="Giorni di consegna e copertura" :back-label="backLabel" save-label="Salva" :save-disabled="saving" @back="back" @save="salva">
				<v-row dense>
					<v-col cols="12" lg="5">
						<SectionCard title="Valori generali" icon="mdi-calendar-clock">
							<v-text-field
								v-model.number="defaults.leadDays"
								type="number"
								min="0"
								label="Giorni di consegna del fornitore"
								suffix="giorni"
								outlined
								dense
								hint="Da quando ordini a quando la merce è in magazzino"
								persistent-hint
								class="mb-3"
							/>
							<v-text-field
								v-model.number="defaults.coverDays"
								type="number"
								min="0"
								label="Giorni da coprire con l'ordine"
								suffix="giorni"
								outlined
								dense
								hint="Quanti giorni di vendite deve durare la merce ordinata"
								persistent-hint
								class="mb-3"
							/>
							<v-text-field
								v-model.number="defaults.safetyDays"
								type="number"
								min="0"
								label="Scorta di sicurezza"
								suffix="giorni"
								outlined
								dense
								hint="Margine per ritardi o picchi di vendita"
								persistent-hint
							/>
							<div class="is-note mt-4">
								Si riordina quando il disponibile scende sotto le vendite previste per consegna + sicurezza. La quantità proposta copre consegna + copertura + sicurezza, meno quello che c'è.
							</div>
						</SectionCard>
					</v-col>
					<v-col cols="12" lg="7">
						<SectionCard title="Eccezioni per fornitore" icon="mdi-truck-outline" subtitle="vuoto = valore generale" no-padding>
							<v-simple-table dense>
								<thead>
									<tr>
										<th>Fornitore</th>
										<th style="width: 110px">Consegna</th>
										<th style="width: 110px">Copertura</th>
										<th style="width: 110px">Sicurezza</th>
										<th style="width: 44px"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(s, i) in rows" :key="i">
										<td><v-autocomplete v-model="s.supplier" :items="supplierItems" dense hide-details single-line placeholder="Fornitore" /></td>
										<td><v-text-field v-model="s.leadDays" type="number" min="0" dense hide-details single-line :placeholder="String(defaults.leadDays)" suffix="gg" /></td>
										<td><v-text-field v-model="s.coverDays" type="number" min="0" dense hide-details single-line :placeholder="String(defaults.coverDays)" suffix="gg" /></td>
										<td><v-text-field v-model="s.safetyDays" type="number" min="0" dense hide-details single-line :placeholder="String(defaults.safetyDays)" suffix="gg" /></td>
										<td>
											<v-btn icon small title="Togli" @click="rows.splice(i, 1)"><v-icon small>mdi-close</v-icon></v-btn>
										</td>
									</tr>
									<tr v-if="!rows.length">
										<td colspan="5" class="grey--text py-3">Nessuna eccezione: tutti i fornitori usano i valori generali.</td>
									</tr>
								</tbody>
							</v-simple-table>
							<div class="pa-2">
								<v-btn text small color="primary" @click="rows.push({ supplier: null, leadDays: '', coverDays: '', safetyDays: '' })"><v-icon small left>mdi-plus</v-icon>Aggiungi fornitore</v-btn>
							</div>
						</SectionCard>
					</v-col>
				</v-row>
			</FormPage>
		</v-container>
	</v-main>
</template>

<script>
import { mapActions } from 'vuex';
import FormPage from '@/components/core/FormPage.vue';
import SectionCard from '@/components/core/SectionCard.vue';

export default {
	name: 'FinanceInventorySettings',
	components: { FormPage, SectionCard },
	data() {
		return { defaults: { leadDays: 7, coverDays: 30, safetyDays: 7 }, rows: [], suppliers: [], saving: false };
	},
	computed: {
		backLabel() {
			return 'Torna al report scorte';
		},
		supplierItems() {
			return this.suppliers.map(s => ({ value: s._id, text: s.Company || '—' }));
		},
	},
	async mounted() {
		try {
			const res = await this.fetchSettings();
			this.suppliers = res.suppliers || [];
			this.defaults = { ...this.defaults, ...((res.settings && res.settings.defaults) || {}) };
			this.rows = ((res.settings && res.settings.suppliers) || []).map(s => ({
				supplier: String(s.supplier),
				leadDays: s.leadDays === null || s.leadDays === undefined ? '' : s.leadDays,
				coverDays: s.coverDays === null || s.coverDays === undefined ? '' : s.coverDays,
				safetyDays: s.safetyDays === null || s.safetyDays === undefined ? '' : s.safetyDays,
			}));
		} catch (err) {
			this.notify('error', err.message);
		}
	},
	methods: {
		...mapActions({ fetchSettings: 'finance/fetchInventorySettings', saveSettings: 'finance/saveInventorySettings', startRefresh: 'finance/startRefresh' }),
		back() {
			this.$router.push('/finance/inventory');
		},
		async salva() {
			this.saving = true;
			try {
				await this.saveSettings({ defaults: this.defaults, suppliers: this.rows.filter(r => r.supplier) });
				// le proposte dipendono da questi giorni: si ricalcolano subito
				await this.startRefresh({ kind: 'inventory' });
				this.notify('success', 'Salvato: le proposte di riordino si stanno ricalcolando');
				this.back();
			} catch (err) {
				this.notify('error', (err.response && err.response.data && err.response.data.message) || err.message);
			} finally {
				this.saving = false;
			}
		},
		notify(color, text) {
			this.$store.dispatch('settings/updateSnackbar', { color, text, snackbar: true, mode: 'multi-line', timeout: 5000 });
		},
	},
};
</script>

<style scoped>
.is-note {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
